import { useId } from 'react';

interface MiniNumberFieldProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
}

/**
 * Compact inline numeric field (string-valued, decimal input mode) for dense
 * parameter rows, e.g. "From % / To % / Step %" triplets.
 */
const MiniNumberField = ({ label, value, onChange, placeholder, disabled = false }: MiniNumberFieldProps) => {
    const fieldId = useId();

    return (
        <div>
            <label className="mb-1 block text-xs font-medium text-zinc-400" htmlFor={fieldId}>
                {label}
            </label>
            <input
                className="h-[38px] w-24 rounded-md border border-[#444] bg-[#1E1E1E] px-2 text-sm text-zinc-200 outline-none focus:border-[#888] disabled:cursor-not-allowed disabled:opacity-60"
                disabled={disabled}
                id={fieldId}
                inputMode="decimal"
                placeholder={placeholder}
                value={value}
                onChange={(event) => onChange(event.target.value)}
            />
        </div>
    );
};

export default MiniNumberField;
